/* unplugin-vue-components disabled */import { render } from "./ResourceCenter.vue?vue&type=template&id=8f52a864&scoped=true"
import script from "./ResourceCenter.vue?vue&type=script&lang=js"
export * from "./ResourceCenter.vue?vue&type=script&lang=js"

import "./ResourceCenter.vue?vue&type=style&index=0&id=8f52a864&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-成都工业学院-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f52a864"]])

export default __exports__